export type ItemProgressState = 'Completed' | 'Started' | 'NotStarted';

export enum ItemProgress {
  COMPLETED = 'Completed',
  STARTED = 'Started',
  NOT_STARTED = 'NotStarted',
}
